// extracted by mini-css-extract-plugin
export default {"card":"Card_card__3Y5J1","cardItem":"Card_cardItem__mkqtP","image":"Card_image__0Felg","content":"Card_content__TgoMk","btnn":"Card_btnn__wRuKE"};